import { Typography } from '@musinsa/mds';

export const EmptyMyShopCurationList = () => (
  <div className="flex flex-1 px-4 py-10 flex-col justify-center items-center bg-gray-100">
    <Typography variant="body14pxMed">+버튼을 눌러 큐레이션을 추가해보세요.</Typography>
  </div>
);
